import 'bootstrap';

$('.form-track').submit(function(e) {
	e.preventDefault();
	$('#popupTrack iframe').attr('src', 'https://soprano.mosistemas.com/app/rastreamento/#/?url=soprano');								
	$('#popupTrack').modal('show');
	/*
	Campos de busca, para carregar somente os resultados.
	var form = $(this);
	if (!form.hasClass('loading')) {
		form.addClass('loading');
		$.ajax({
			url: form.attr('action'),
			type: 'POST',
			dataType: 'json',
			data: form.serialize(),
			error: function() {
				console.error('Error searching track');
				Swal.fire({
					title: jsi18n.ajax_error_title,
					text: jsi18n.ajax_error_message,
					imageUrl: site_url + 'site/img/iconError.png',
					imageWidth: 76,
					imageHeight: 76
				});
				form.removeClass('loading');
			},
			success: function(json) {
				if (json.status) {	

					$('#popupTrack iframe').attr('src', json.url);								
					$('#popupTrack').modal('show');

					form[0].reset();
				} else {
					Swal.fire({
						title: json.title,
						text: json.message,
						imageUrl: site_url + 'site/img/iconError.png',
						imageWidth: 76,
						imageHeight: 76
					});
				}
				form.removeClass('loading');
			}
		});
	}*/
});